import Tile from './tile';
export default Tile;
